import React from 'react';
import Section from './Section';
import styled from 'styled-components';
import classNames from 'classnames';
import Stack from '@mui/material/Stack';
import { EditorControl } from "@clatter/templates";

const StyledOptionalCopyBlockSection = styled(Section)`
  background-color: ${({ $inBetweenWhiteSections, backgroundColor, theme }) => {
    if (backgroundColor) {
      return backgroundColor;
    }

    if ($inBetweenWhiteSections) {
      return theme.optionalSection.backgroundColorInBetweenWhite;
    }

    return theme.optionalSection.backgroundColor;
  }};
  padding: ${({ theme }) => theme.optionalSection.padding};

  color: ${({ theme }) => theme.optionalSection.copy.color};
  font-family: ${({ theme }) => theme.optionalSection.copy.fontFamily};
  font-size: ${({ theme }) => theme.optionalSection.copy.fontSize};
  white-space: ${({ theme }) => theme.optionalSection.copy.whiteSpace};
  margin: 0;

  &.border-top {
    border-top: 1px solid lightgray;
  }

  &.border-bottom {
    border-bottom: 1px solid lightgray;
  }

  h1 {
    color: ${({ theme }) => theme.optionalSection.title.color};
    font-family: ${({ theme }) => theme.optionalSection.title.fontFamily};
    font-size: ${({ theme }) => theme.optionalSection.title.fontSize};
  }

  &.no-border-bottom {
    border-bottom: none;
  }
`;

const StyledOptionalCopyBlockButton = styled.button`
  cursor: pointer;
  position: relative;
  display: inline-block;
  min-width: 170px;
  padding: ${({ theme }) => theme?.button?.padding || theme.optionalSection?.button.padding};
  color: ${({ theme }) => theme?.button?.color || theme.optionalSection?.button.color};
  background-color: ${({ theme }) =>
    theme?.button?.backgroundColor || theme.optionalSection?.button.backgroundColor};
  border: ${({ theme }) => theme?.button?.border || theme.optionalSection?.button.border};
  border-radius: ${({ theme }) => theme?.button?.borderRadius || theme.optionalSection?.button.borderRadius};
  font-family: ${({ theme }) => theme.optionalSection?.button.fontFamily};
  font-size: ${({ theme }) => theme?.button?.fontSize || theme.optionalSection?.button.fontSize};
  font-weight: ${({ theme }) => theme?.button?.fontWeight || theme.optionalSection?.button.fontWeight};

  &:hover {
    color: ${({ theme }) => theme?.button?.hover?.color};
    background-color: ${({ theme }) => theme?.button?.hover?.backgroundColor};
    border-color: ${({ theme }) => theme?.button?.hover?.borderColor};
  }

  align-self: flex-start;
`;

const OptionalCopyBlockButton = ({ url, label = 'Button' }) => {
  const handleClick = () => {
    if (url) {
      window.open(url, '_blank', 'noopener');
    }
  };

  return (
    <StyledOptionalCopyBlockButton
      type="button"
      onClick={() => handleClick()}
      alt={url}
    >
      {label}
    </StyledOptionalCopyBlockButton>
  );
};

const OptionalCopyBlockItem = ({
  item,
  backgroundColor,
  listItem = false,
  showBorder = false,
  sectionContainer = false,
  linkColor,
  noBorderBottom,
  inBetweenWhiteSections = false,
}) => {
  return (
    <StyledOptionalCopyBlockSection
      className={classNames({
        'border-top': showBorder,
        'border-bottom': listItem,
        'no-border-bottom': noBorderBottom,
      })}
      backgroundColor={backgroundColor}
      container={sectionContainer}
      $inBetweenWhiteSections={inBetweenWhiteSections}
    >
      {!!item?.headline && <h1 className="optional-copy-block-headline">{item?.headline}</h1>}
      <Stack direction={{ xs: 'column', md: 'row' }} spacing={7}>
        <EditorControl readOnly noScrollbars value={item?.description} linkColor={linkColor} />
        {item?.showButton && (
          <OptionalCopyBlockButton
            url={item?.buttonUrl}
            label={item?.buttonText}
          />
        )}
      </Stack>
    </StyledOptionalCopyBlockSection>
  );
};

const OptionalCopyBlockSection = ({
  data,
  backgroundColor,
  heroSection,
  showBorder = false,
  linkColor,
  inBetweenWhiteSections = false,
}) => {
  if (!data?.length) {
    return null;
  }

  if (heroSection) {
    return (
      <OptionalCopyBlockItem
        showBorder={showBorder}
        item={data[0]}
        backgroundColor={backgroundColor}
        linkColor={linkColor}
        inBetweenWhiteSections={inBetweenWhiteSections}
      />
    );
  }

  return (
    <>
      {data?.map((item, index) => {
        if (!item?.enabled) {
          return null;
        }
        return (
          <OptionalCopyBlockItem
            item={item}
            key={index}
            backgroundColor={backgroundColor}
            sectionContainer
            listItem
            linkColor={linkColor}
            noBorderBottom={!data?.[1].enabled || index === data?.length - 1} // for now there could be only two items in the "data"
            inBetweenWhiteSections={inBetweenWhiteSections}
          />
        );
      })}
    </>
  );
};

export default OptionalCopyBlockSection;
